/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_DurationInputs */

const vi_irrigation_schedule_duration = /** @type {(inputs: Irrigation_Schedule_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi lần tưới (phút)`)
};

/**

* @param {Irrigation_Schedule_DurationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_duration = /** @type {((inputs?: Irrigation_Schedule_DurationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_DurationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_duration(inputs)
});